module.exports = __webpack_public_path__ + "static/media/file-alt.af630b38.svg";